/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Abdul Raheem",
  title: "Hi all, I'm Abdul Raheem",
  subTitle: emoji(
    "A passionate Full Stack Software Developer 🚀 having an experience of building Web applications with JavaScript / Reactjs / Nodejs and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1LCS9wbbAMLRCiaaGhjtDTCsdJgTrL7uP/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/sfsraheem",
  linkedin: "https://www.linkedin.com/in/se-abdulraheem/",
  gmail: "sfsraheem222@gmail.com",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Played a key role in developing and maintaining RESTful APIs using Expressjs and Nestjs"
    ),
    emoji(
      "⚡ Developed dynamic and responsive front-end interfaces using React and managed state efficiently with Redux Toolkit"
    ),
    emoji(
      "⚡ Integrated GraphQL to provide a flexible and efficient way to query and manipulate data, optimizing API performance and client experience"
    ),
    emoji(
      "⚡ Deployed Node.js servers on AWS EC2, Digital Ocean, and GCP, ensuring high availability and scalability"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "ExpressJs",
      fontAwesomeClassname: "fas fa-server"
    },
    {
      skillName: "MongoDB",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "Nestjs",
      fontAwesomeClassname: "fas fa-cubes"
    },
    {
      skillName: "NPM",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "SQL",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "Reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "Redux Toolkit",
      fontAwesomeClassname: "fas fa-tools"
    },
    {
      skillName: "AWS",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "Nginx",
      fontAwesomeClassname: "fas fa-server"
    },
    {
      skillName: "GraphQL",
      fontAwesomeClassname: "fas fa-project-diagram"
    },
    {
      skillName: "REST API",
      fontAwesomeClassname: "fas fa-network-wired"
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Government College University Faisalabad",
      logo: require("./assets/images/gcuf.png"),
      subHeader: "Bachelor in Computer Science",
      // duration: "September 2019 - September 2023",
      desc: "Comprehensive Bachelor of Science in Computer Science with a Focus on Web App Development and Core CS Principles",
      descBullets: [
        "Completed a Bachelor of Science in Computer Science, gaining in-depth knowledge in Object-Oriented Programming (OOP), Operating Systems (OS), and Data Structures and Algorithms (DSA).",
        "Specialized in web application development, creating dynamic and scalable applications using modern technologies.",
        "Developed a strong understanding of both front-end and back-end development, ensuring a comprehensive approach to software solutions."
      ]
    },
    {
      schoolName: "Punjab Group of Colleges",
      logo: require("./assets/images/pgc.png"),
      subHeader: "Intermediate in Computer Science (ICS)",
      // duration: "September 2016 - September 2018",
      desc: "Studied fundamental programming concepts and algorithms using C language.",
      descBullets: [
        "Gained a strong foundation in computer science principles, including data structures and problem-solving techniques."
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Backend",
      progressPercentage: "95%"
    },
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "70%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Deployment",
      progressPercentage: "80%"
    }
  ]
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer",
      company: "TxLabz",
      companylogo: require("./assets/images/txlabz.png"),
      date: "October 2023 – Present",
      desc: "Integral member of the development team, responsible for creating efficient server-side solutions.",
      descBullets: [
        "Worked on multiple complex projects, contributing to scalable and maintainable solutions.",
        "Led a full-stack development team on select projects, ensuring timely and quality deliverables.",
        "Utilized a broad range of technologies including Node.js, TypeScript, MongoDB, PostgreSQL, MySQL, and AWS services (EC2, S3, Lambda, API Gateway).",
        "Developed efficient backend systems using Prisma, Nest.js, Elasticsearch, and third-party integrations.",
        "Integrated multiple CRMs (HubSpot, Salesforce, GoHighLevel) for OAuth and resource management.",
        "Built real-time systems with Socket.IO and advanced APIs using GraphQL.",
        "Recognized with the 'Rising Star Award' during the probation period for outstanding performance."
      ]
    },
    {
      role: "Software Engineer",
      company: "Smartfun Studios",
      companylogo: require("./assets/images/sfs.png"),
      date: "October 2022 - October 2023",
      desc: "Played a key role in the development and maintenance of RESTful APIs using Express.js, ensuring high scalability and robustness.",
      descBullets: [
        "Started my career as a backend developer, contributing to scalable solutions for diverse projects.",
        "Developed a salon booking app utilizing Node.js, Express.js, MongoDB, Firebase for cloud messaging, and cron jobs for automation.",
        "Worked on projects leveraging headless CMS solutions like Strapi to deliver flexible and dynamic content management systems.",
        "Awarded 'Employee of the Year' for exceptional contributions and performance."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/agerlink-logo.png"),
      projectName: "Agerlink",
      projectDesc:
        "AgerLink is an innovative, all encompassing platform designed to revolutionize the agri-food sector.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://agerlink.it/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/xair-logo.png"),
      projectName: "XAir",
      projectDesc:
        "XAir is a modern tech company specializing in simplifying aviation experiences.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.xair.uk/"
        }
      ]
    },
    {
      image: require("./assets/images/hivefolio.png"),
      projectName: "Hivefolio",
      projectDesc:
        "An esports and gaming carer platform. Build your brand, network and discover new job opportunities!",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.hivefolio.gg/home"
        }
      ]
    },
    {
      image: require("./assets/images/league-online.png"),
      projectName: "League Online",
      projectDesc: "Online learning platform for Singapore closed community.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.leagueonline.sg/#/"
        }
      ]
    },
    {
      image: require("./assets/images/sgbf-logo.png"),
      projectName: "Saudi Green Building Forum",
      projectDesc:
        "The Leading Voice for Sustainable Development Goals in the West Asia.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://sgbf.sa/"
        }
      ]
    },
    {
      image: require("./assets/images/excellcare.png"),
      projectName: "ExcellCare (Admin Dashboard)",
      projectDesc: "Admin and Staff dashboard for managing tasks.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://connect.excellcare.ca/login"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Rising Star Award",
      subtitle:
        "The rising star award given by the TxLabz for outstanding performance and dedication to the company.",
      image: require("./assets/images/txlabz.png"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "View Post",
          url: "https://www.linkedin.com/posts/abdul-raheem-25047b198_risingtalent-careermilestone-activity-7138942610424987648-nuAO?utm_source=share&utm_medium=member_desktop"
        },
        {
          name: "View Award",
          url: "https://drive.google.com/file/d/1diceZ6jxRWEwGfNIsxA_4fzAEPZbuWuJ/view?usp=sharing"
        }
      ]
    },
    {
      title: "Employee of the Year",
      subtitle:
        "Employee of the year award given by the Smartfun Studios for dedication and hard work.",
      image: require("./assets/images/sfs.png"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Post",
          url: "https://www.linkedin.com/posts/smartfunstudios_employee-appreciation-efforts-activity-7092836049873178624-4dN_?utm_source=share&utm_medium=member_desktop"
        }
      ]
    },

    {
      title: "Blockchain Prgramming Certification",
      subtitle:
        "Certified Blockchain Programmer by National Vocational and Technical Training Commission(NAVTTC).",
      image: require("./assets/images/navttc.png"),
      imageAlt: "PWA Logo",
      footerLink: [
        {
          name: "View Certificate",
          url: "https://drive.google.com/file/d/1uZBGPhGN8y7jLQ2OVzb_4yC1DAU63rLf/view?usp=sharing"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ]
  // display: true // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ]
  // display: true // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ]
  // display: true // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+92-0000000000",
  email_address: "saadpasta70@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter" //Replace "twitter" with your twitter username without @
  // display: true // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
